/* eslint-disable jsx-a11y/no-static-element-interactions, react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { paths } from 'constants';
import Svg from '@justgiving/svg';
import tickIcon from '@justgiving/icons/lib/tick.svg';
import { formatPhoneNumberForDisplay } from 'utils/format';
import { track } from 'utils/koala-analytics';
import { Trans } from 'react-i18next';

const propTypes = {
  number: PropTypes.string,
};

const defaultProps = {
  number: undefined,
};

const trackAddPhone = () => {
  const trackingData = {
    event: 'link click',
    subtype: 'hyperlink',
    page_section: 'personal details > phone',
    event_value: 'add',
  };
  track(trackingData);
};

const trackEditPhone = () => {
  const trackingData = {
    event: 'link click',
    subtype: 'hyperlink',
    page_section: 'personal details > phone',
    event_value: 'edit',
  };
  track(trackingData);
};

const AddPhone = () => (
  <>
    <p className="jg-text--medium-light">
      <Trans i18nKey="personalDetails.mobileNumber">Mobile number</Trans>
    </p>
    <p className="jg-text--medium-light">
      <Link to={paths.Phone} onClick={trackAddPhone} className="qa-link__phone">
        <Trans i18nKey="personalDetails.addMobileNumber">
          Add mobile number
        </Trans>
      </Link>
    </p>
  </>
);

const ChangePhone = props => (
  <>
    <p className="jg-text--medium-light">
      <Trans i18nKey="personalDetails.mobileNumber">Mobile number</Trans>
    </p>
    <div className="jg-text--dark">
      <span className="jg-text--dark data-value">
        {formatPhoneNumberForDisplay(props.number)}
      </span>
      {props.number && (
        <span>
          <Svg
            className="jg-space-mlsm jg-display-i jg-icon--medium-small phone-number-tick"
            markup={tickIcon}
          />{' '}
          Verified
        </span>
      )}
      <Link
        to={paths.Phone}
        onClick={trackEditPhone}
        className="jg-edit-link jg-space-mlsm qa-link__phone"
      >
        <Trans i18nKey="personalDetails.edit">Edit</Trans>
      </Link>
    </div>
  </>
);

const Phone = props => (
  <div className="details-block">
    <div className="jg-space-phsm@sm jg-space-phn@lg">
      {props.number ? ChangePhone(props) : AddPhone()}
    </div>
  </div>
);

Phone.propTypes = propTypes;

Phone.defaultProps = defaultProps;

export default Phone;
